import { useEffect, useState } from 'react';

interface VirtualKeyboardGeometryChangeEvent {
    target: {
        boundingRect: {
            height: number;
        };
    };
}

interface NavigatorWithVirtualKeyboard extends Navigator {
    virtualKeyboard?: {
        overlaysContent: boolean;
        addEventListener: (type: string, listener: (event: VirtualKeyboardGeometryChangeEvent) => void) => void;
        removeEventListener: (type: string, listener: (event: VirtualKeyboardGeometryChangeEvent) => void) => void;
    };
    userAgentData?: {
        mobile?: boolean;
    };
}

const DEFAULT_BOTTOM = '24px';

const supportsVirtualKeyboard = (nav: NavigatorWithVirtualKeyboard): boolean => Boolean(nav.userAgentData?.mobile && nav.virtualKeyboard);

const useDynamicHeightButton = (isSingleInput: boolean): string => {
    const [buttonBottom, setButtonBottom] = useState(DEFAULT_BOTTOM);

    useEffect(() => {
        if (typeof navigator === 'undefined') {
            return;
        }

        const nav = navigator as NavigatorWithVirtualKeyboard;
        if (!supportsVirtualKeyboard(nav)) {
            return;
        }

        const virtualKeyboard = nav.virtualKeyboard!;

        const handleGeometryChange = (event: VirtualKeyboardGeometryChangeEvent): void => {
            const height = event.target?.boundingRect?.height ?? 0;
            setButtonBottom(height > 0 ? `${height + 24}px` : DEFAULT_BOTTOM);
        };

        virtualKeyboard.overlaysContent = Boolean(isSingleInput);
        if (isSingleInput) {
            virtualKeyboard.addEventListener('geometrychange', handleGeometryChange);
        }

        return () => {
            virtualKeyboard.removeEventListener('geometrychange', handleGeometryChange);
        };
    }, [isSingleInput]);

    return buttonBottom;
};

export { useDynamicHeightButton };
